import Resource from '@/api/resources/Resource'

class NotificationService extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/notifications`, filterModel, { params })
        return response.data
    }

    async updateNotificationAsRead(id) {
        return this.axios.put(`/notifications/${id}/markAsRead`)
            .then(response => response.data)
    }

    async updateAllNotificationAsRead(isAlarm) {
        return this.axios.put(`/notifications/markAllAsRead`,
            {}, { params: { isAlarm: isAlarm } })
            .then(response => response.data)
    }
}

export default new NotificationService()
